import React from 'react';
import './Alumni.css';
import { SectionWrapper } from '../../hoc';
import {connect, contact, donate} from '../../assets';

function Alumni() {
  return (
    <div className="alumni-container">
      <h1>Alumni</h1>
      
      <h2>Welcome! This is the National Society of Black Engineers Alumni Page, where we connect with and promote the benefits for our involved Alumni. We offer tax exemptions on donations, Alumni giveaways, professional development events, volunteering opportunities, and a brilliant pool of Louisiana Tech NSBE talent. Whether you’re a Louisiana Tech Alumni or a professional looking to get involved in a college organization, the National Society of Black Engineers at Louisiana Tech is the place for you! Contact us today and with your help, we will change tomorrow!</h2>
      <div class="row">
        <div class = "column">
          <h3> Contact Us! </h3>
            <img src={contact} alt="email icon" class="alumni-icon"/>
            <br /> 
          <a href="mailto:mga037@email.latech.edu"><p class="alum-button">E-Mail</p></a>
        </div>

        <div class = "column">
          <h3> Donate! </h3>
            <img src={donate} alt="donation icon" class="alumni-icon"/>
            <br />
          <a href="https://cash.app/$LaTechNSBE"><p class="alum-button">CashApp</p></a>
        </div>

        <div class = "column">
          <h3> Connect! </h3>
            <img src={connect} alt="connection icon" class="alumni-icon"/>
            <br />
          <a href="https://groupme.com/join_group/108821650/21YljgLV"><p class="alum-button">GroupMe</p></a>
        </div>
      </div>
      
    </div>
  );
}

export default SectionWrapper(Alumni, 'alumni');
